import * as yup from 'yup';

export const RiskAssessmentValidationSchema = yup.object({

    confirmedSufficientCapacity: yup.boolean()
        .required('Confirmed sufficient capacity is required'),

    areThereRelatedParties: yup.boolean()
        .required('Are there Related Parties is required'),
    isTheTechnicalSignatoryImpartial: yup.boolean()
        .required('Is the Technical Signatory impartial is required'),
    isTheAllocatedAnalystsImpartial: yup.boolean()
        .required('Is the Allocated Analysts(s) impartial is required'),

    sufficientInformationWasSupplied: yup.boolean()
        .required('Sufficient information was supplied is required'),
    verificationRequirementsProvided: yup.boolean()
        .required('Verification requirements provided is required'),
    confirmedNoDifferencesInUnderstanding: yup.boolean()
        .required('Confirmed that there are no differences in understanding is required'),

    additionalText: yup
        .string()
        .nullable()
        .max(1000, 'Max character limit of 1000 reached'),
});
